import { defineMessages } from 'react-intl';

/** The sound profile state on Find, Your sound and the Pitch home (`ProfileStateBar.tsx`). */
export const profileStateMessages = defineMessages({
  missing: { id: 'app.outreach.profileState.missing', defaultMessage: 'Plug needs your sound profile first.' },
  missingSub: {
    id: 'app.outreach.profileState.missingSub',
    defaultMessage: 'Plug reads your songs and playlists, then ranks who fits you.',
  },
  build: { id: 'app.outreach.profileState.build', defaultMessage: 'Build my sound profile' },
  buildingSub: {
    id: 'app.outreach.profileState.buildingSub',
    defaultMessage: 'Your sound profile is building. The fits show here when it ends.',
  },
  failed: {
    id: 'app.outreach.profileState.failed',
    defaultMessage: 'Plug could not build your sound profile.',
  },
  failedSub: {
    id: 'app.outreach.profileState.failedSub',
    defaultMessage: 'Try again. The fits stay as they were until the build ends.',
  },
  ready: { id: 'app.outreach.profileState.ready', defaultMessage: 'Your sound profile is ready.' },
  readySub: {
    id: 'app.outreach.profileState.readySub',
    defaultMessage: 'Next: see who fits {song}.',
  },
  readySubNoSong: {
    id: 'app.outreach.profileState.readySubNoSong',
    defaultMessage: 'Next: see who fits your sound.',
  },
  findWhoFits: { id: 'app.outreach.profileState.findWhoFits', defaultMessage: 'Find who fits' },
});
